<template>
  <v-menu top left offset-y ref="alertAction">
    <v-btn :id="alertActionBtnId(alert.id)" :aria-label="alertActionBtnId(alert.id)" slot="activator" icon>
      <v-icon>more_vert</v-icon>
    </v-btn>
    <v-list role="menu" class="py-0">
      <v-list-tile @click="copyClick">
        <v-list-tile-title :id="alertDuplicateId(alert.id)" :aria-label="alertDuplicateId(alert.id)">
          <v-icon class="pr-2">file_copy</v-icon>
          {{$t('admin.alerts.new.duplicate')}}
        </v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="editClick">
        <v-list-tile-title :id="alertEditId(alert.id)" :aria-label="alertEditId(alert.id)">
          <v-icon class="pr-2">build</v-icon>
          {{$t('admin.alerts.new.edit')}}
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script>
  import { COPY_ALERT } from '../../../store/action-types'
  import { mapActions } from 'vuex'

  export default {
    name: 'alert-row-action',
    props: {
      alert: {
        type: Object
      }
    },
    methods: {
      ...mapActions({
        copyAlert: COPY_ALERT
      }),
      alertActionBtnId (key) {
        return `alert-${key}-action`
      },
      alertEditId (key) {
        return `alert-${key}-edit`
      },
      alertDuplicateId (key) {
        return `alert-${key}-duplicate`
      },
      editClick () {
        this.$router.push({name: 'AlertDetails', params: {id: this.alert.id}})
      },
      copyClick () {
        this.copyAlert(this.alert.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertRowAction.vue